import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { ExtraWideBody } from '@ui';
import { Page } from '@ui';
import { AgentScript } from '@containers/WorkflowChart/AgentScript';

const PageWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export function FlowAgentScript() {
  return (
    <>
      <Header />
      <ExtraWideBody>
        <PageWrapper>
          <Page width={'2440px'} noPadding>
            <AgentScript />
          </Page>
        </PageWrapper>
      </ExtraWideBody>
    </>
  );
}
